import React from "react";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import "./GrupoQuestaoCard.css";

const formatarDataHora = (valor) => {
  if (!valor) return "Nao informado";
  const data = new Date(valor);
  if (Number.isNaN(data.getTime())) return "Nao informado";
  return `${data.toLocaleDateString("pt-BR")} - ${data.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
};

const GrupoQuestaoCard = ({ grupo, onClick, actions = [] }) => {
  return (
    <li
      className={`grupo-questao-card ${onClick ? "grupo-questao-card-clickable" : ""}`}
      onClick={() => onClick?.(grupo)}
    >
      <div className="grupo-questao-card-left">
        <strong className="grupo-questao-card-title">{grupo.descricao}</strong>
        <div className="grupo-questao-card-meta">
          <span className="grupo-questao-meta-label">Grupo modelo:</span>
          {Number(grupo.questaoModelo) === 1 ? (
            <FaCheckCircle className="grupo-questao-icon-yes" />
          ) : (
            <FaTimesCircle className="grupo-questao-icon-no" />
          )}
        </div>
      </div>

      <div className="grupo-questao-card-right">
        <div className="grupo-questao-row">
          <span className="grupo-questao-meta-label">Situacao:</span>
          <span className={Number(grupo.situacao) === 1 ? "grupo-tag-ativo" : "grupo-tag-inativo"}>
            {Number(grupo.situacao) === 1 ? "Ativo" : "Inativo"}
          </span>
        </div>
        <div className="grupo-questao-row">
          <span className="grupo-questao-meta-label">Presente em:</span>
          <span className="grupo-questao-meta-value">
            {Number(grupo.qntSecoes || 0)} {Number(grupo.qntSecoes || 0) === 1 ? "secao" : "secoes"}
          </span>
        </div>
        <div className="grupo-questao-row">
          <span className="grupo-questao-meta-label">Questoes:</span>
          <span className="grupo-questao-meta-value">
            {Number(grupo.qntQuestoes || 0)} {Number(grupo.qntQuestoes || 0) === 1 ? "questao" : "questoes"}
          </span>
        </div>
        <div className="grupo-questao-row">
          <span className="grupo-questao-meta-label">Atualizado em:</span>
          <span className="grupo-questao-meta-value">
            {formatarDataHora(grupo.dataAlteracao || grupo.dataCadastro)}
          </span>
        </div>
        {!!actions.length && (
          <div className="grupo-questao-actions">
            {actions.map((action) => (
              <button
                key={action.key}
                type="button"
                className={`grupo-questao-btn ${action.className || ""}`}
                onClick={(event) => {
                  event.stopPropagation();
                  action.onClick?.(grupo);
                }}
                disabled={Boolean(action.disabled)}
              >
                {action.icon && <span className="grupo-questao-btn-icon">{action.icon}</span>}
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </li>
  );
};

export default GrupoQuestaoCard;
